import { forwardRef } from 'react'
import { Tooltip } from '@base-ui/react/tooltip'
import { twMerge } from 'tailwind-merge'

/** Long enough that a pointer passing over doesn't flash a tooltip. */
export const TOOLTIP_DELAY = 300

export interface TooltipTriggerProps extends Tooltip.Trigger.Props {
  className?: string
}

const TooltipTrigger = forwardRef<HTMLButtonElement, TooltipTriggerProps>(function TooltipTrigger(
  { className, render, delay = TOOLTIP_DELAY, ...props },
  ref,
) {
  return (
    <Tooltip.Trigger
      ref={ref}
      // A rendered element brings its own styling; the reset would strip its padding and fill.
      className={render ? className : twMerge('inline-flex bg-transparent p-0', className)}
      render={render}
      delay={delay}
      {...props}
    />
  )
})

export { TooltipTrigger }
